import React, {useEffect, useRef, useState} from "react";
import {useLocation, useNavigate, useParams, Link} from "react-router-dom";
import {Breadcrumb, Button, Form, Progress, Segmented, Slider, Switch, message, Tooltip} from "antd";
import {useCookies} from "react-cookie";
import dayjsInstance from "../utils/dayjs";
import SpeechRecognition, {useSpeechRecognition} from 'react-speech-recognition';
import TextArea from "antd/es/input/TextArea";
import axios from "axios";
import {
    AudioFilled, DownloadOutlined, VideoCameraOutlined, SoundOutlined,
    StepBackwardOutlined, StepForwardOutlined, PlayCircleFilled, PauseCircleFilled,
    SettingOutlined, HomeOutlined, CheckOutlined, EyeOutlined, EyeInvisibleOutlined,
    RetweetOutlined, FontSizeOutlined
} from "@ant-design/icons";
import convertTimeToMilliseconds from "../utils/convertTimeToMilliseconds";
import toLowerCamelCase from "../utils/toLowerCamelCase";
import {createUserListening, getUserListening} from "../apis/userListening";
import {Lrc} from "react-lrc";

export default function Listening() {
    const {slug} = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const index = location?.state?.index;
    const [form] = Form.useForm();
    const audioElem = useRef();
    const lyricsContainerRef = useRef();

    const [dataLesson, setdataLesson] = useState({});
    const [options, setOptions] = useState([]);
    const [story, setStory] = useState("Main Story");
    const [dataUserListening, setDataUserListening] = useState([]);
    const [showAnswer, setShowAnswer] = useState(false);
    const [isPlaying, setisPlaying] = useState(false);
    const [currentTime, setcurrentTime] = useState(0);
    const [speedMode, setSpeedMode] = useState(1);
    const [active, setActive] = useState(0);
    const [playAll, setPlayAll] = useState(false);
    const [timestamps, setTimestamps] = useState({});
    const [duration, setDuration] = useState(0);
    const [count, setCount] = useState(1);
    const [replay, setReplay] = useState(1);
    const [timeReplay, setTimeReplay] = useState(0.5);
    const [timeoutPlay, setTimeoutPlay] = useState(null);
    const [lyric, setLyric] = useState([]);
    const [showSettings, setShowSettings] = useState(false);
    const [isRecording, setIsRecording] = useState(false);
    const [mediaRecorder, setMediaRecorder] = useState(null);
    const [recordedChunks, setRecordedChunks] = useState([]);
    const [totalDuration, setTotalDuration] = useState(0);
    const [subtitleFontSize, setSubtitleFontSize] = useState(16);
    const [translationFontSize, setTranslationFontSize] = useState(14);
    const [showTranslation, setShowTranslation] = useState(false);
    const [autoScroll, setAutoScroll] = useState(true);

    const speeds = [0.5, 0.75, 0.8, 0.9, 1, 1.25, 1.5, 2];

    const isAudioUrl = (url) => {
        if (!url) return false;
        if (typeof url !== 'string') return false;
        return /\.(mp3|m4a|wav|ogg|webm|aac)(\?.*)?$/i.test(url) || /^data:audio\//.test(url);
    };

    const proxyIfR2 = (u) => {
        if (!u || typeof u !== 'string') return u;
        if (u.includes('.r2.cloudflarestorage.com')) {
            const proxyBase = (process.env.REACT_APP_API_URL || '');
            return `${proxyBase.replace(/\/$/, '')}/media/proxy?url=${encodeURIComponent(u)}`;
        }
        return u;
    };

    const resolveAudio = (val) => {
        if (!val) return null;
        if (typeof val === 'string') return isAudioUrl(val) ? val : null;
        if (typeof val === 'object') {
            if (Array.isArray(val) && val.length) {
                const first = val[0];
                if (typeof first === 'string') return isAudioUrl(first) ? first : null;
                if (first && typeof first.url === 'string') return isAudioUrl(first.url) ? first.url : null;
            }
            if (typeof val.url === 'string') return isAudioUrl(val.url) ? val.url : null;
        }
        return null;
    };

    const getAudioSrc = () => {
        const src = story === "Main Story" ? resolveAudio(dataLesson?.mainStoryAudio)
            : story === "Vocabulary" ? resolveAudio(dataLesson?.vocabularyAudio)
            : story === "Mini Story" ? resolveAudio(dataLesson?.miniStoryAudio)
            : null;
        return proxyIfR2(src);
    };

    const [cookies] = useCookies(["user"]);
    const { transcript, listening } = useSpeechRecognition();

    useEffect(() => { lesson(); userListening(); }, []);

    useEffect(() => {
        if (dataUserListening?.lesson_id) {
            if (dayjsInstance(cookies?.user?.vip_expire_at)?.format("YYYY-MM-DD") > dayjsInstance(Date())?.format("YYYY-MM-DD")
                && cookies?.user?.vip_expire_at !== null
                || +dataUserListening?.lesson_id >= +dataLesson.id || +index === 0) {
            } else {
                navigate("/");
            }
        }
        if (index === undefined || !cookies?.user) navigate("/login");
    }, [cookies]);

    useEffect(() => {
        addTimestamps();
        const opts = [];
        if (dataLesson?.mainStory) opts.push('Main Story');
        if (dataLesson?.vocabulary) opts.push('Vocabulary');
        if (dataLesson?.miniStory) opts.push('Mini Story');
        if (dataLesson?.POV) opts.push('POV');
        if (dataLesson?.comment) opts.push('Comment');
        setOptions(opts);
    }, [dataLesson]);

    useEffect(() => {
        try {
            if (duration > 0 && count <= replay && !playAll) {
                const timeoutPlayId = setTimeout(() => {
                    safePlay().then(() => {
                        try { audioElem.current.pause(); } catch(e) {}
                    });
                    if (count === replay) {
                        setisPlaying(false); setDuration(0); setCount(1);
                    } else {
                        const timeout = setTimeout(async () => {
                            await play(active); setCount(count + 1); clearTimeout(timeout);
                        }, timeReplay * 1000);
                    }
                    clearTimeout(timeoutPlayId);
                }, duration * 1000 / speedMode);
                setTimeoutPlay(timeoutPlayId);
            }
        } catch (e) { console.log(e); }
    }, [duration, count]);

    useEffect(() => {
        form.resetFields();
        // Auto-scroll to active lyric line
        if (autoScroll && lyricsContainerRef.current) {
            const activeEl = lyricsContainerRef.current.querySelector(`[data-lyric-index="${active}"]`);
            if (activeEl) {
                activeEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
    }, [active]);
    useEffect(() => { handleLyric(toLowerCamelCase(story)); }, [story, dataLesson]);
    useEffect(() => { if (!listening) form.setFieldsValue({ text: transcript }); }, [listening]);

    useEffect(() => {
        if (audioElem.current) {
            audioElem.current.addEventListener('loadedmetadata', () => {
                setTotalDuration(audioElem.current.duration);
            });
        }
    }, [audioElem.current?.src]);

    const handleLyric = (track) => {
        const startIndex = dataLesson[track]?.indexOf(']') + 1 || 0;
        const l = dataLesson[track]?.split('\n').map(el => el.slice(startIndex));
        setLyric(l);
    };

    const lesson = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/lesson/getBySlug/` + slug);
            setdataLesson(response.data[0]);
        } catch (error) { console.error(error); }
    };

    const userListening = async () => {
        const response = await getUserListening(cookies?.user?.token);
        setDataUserListening(response);
    };

    const onSubmit = async (values) => {
        if (values.text && values.text !== '') {
            await createUserListening({
                lesson_id: dataLesson.id, position: active,
                track: toLowerCamelCase(story), lyric: lyric[active], text: values.text,
            }, cookies?.user?.token);
            await userListening();
        }
        setShowAnswer(!showAnswer);
        await stopMic();
    };

    const onPlaying = () => {
        const ct = audioElem.current.currentTime;
        setcurrentTime(ct * 1000);
        // Auto-advance active sentence in playAll mode
        if (playAll) {
            const ts = timestamps[toLowerCamelCase(story)] || [];
            if (ts.length > 0) {
                let newActive = active;
                for (let i = 0; i < ts.length; i++) {
                    if (ct * 1000 >= ts[i]) {
                        newActive = i;
                    } else {
                        break;
                    }
                }
                if (newActive !== active) {
                    setActive(newActive);
                }
            }
        }
    };

    const changeSpeedMode = (speed) => {
        setSpeedMode(speed);
        audioElem.current.playbackRate = speed;
    };

    const addTimestamps = async () => {
        const temp = {};
        const tracks = ['mainStory', 'miniStory', 'POV', 'comment', 'vocabulary'];
        const keys = ['mainStory', 'miniStory', 'POV', 'comment', 'vocabulary'];
        const dataKeys = ['mainStory', 'miniStory', 'POV', 'comment', 'vocabulary'];
        for (const key of dataKeys) {
            if (dataLesson?.[key]) {
                const mapped = key === 'POV' ? 'pOV' : key;
                temp[mapped] = dataLesson[key].split('\n')
                    .map(el => convertTimeToMilliseconds(el.slice(1, el.indexOf(']'))));
            }
        }
        setTimestamps(temp);
    };

    const safePlay = async () => {
        try {
            if (!audioElem.current) return;
            const src = audioElem.current.src || audioElem.current.currentSrc;
            if (!src) return;
            await audioElem.current.play();
        } catch (err) {
            try { setisPlaying(false); } catch (e) {}
        }
    };

    const play = async i => {
        try {
            const ts = timestamps[toLowerCamelCase(story)];
            audioElem.current.currentTime = ts[i] / 1000;
            await safePlay();
            const endTime = ts[i + 1] / 1000 ? ts[i + 1] / 1000 : i + 1 === ts.length ? audioElem.current.duration : 0;
            setDuration(endTime - ts[i] / 1000);
        } catch (e) { console.log(e); }
    };

    const pause = () => {
        try {
            safePlay().then(() => {
                try {
                    audioElem.current.pause(); setisPlaying(false);
                    setPlayAll(false); setDuration(0); setCount(1); clearTimeout(timeoutPlay);
                } catch (e) {}
            });
        } catch (e) {}
    };

    const PlayPause = async () => {
        if (isPlaying) {
            pause();
            setPlayAll(false);
        } else {
            // Play the full audio from the current active sentence
            try {
                const ts = timestamps[toLowerCamelCase(story)];
                if (ts && ts[active] !== undefined) {
                    audioElem.current.currentTime = ts[active] / 1000;
                }
                audioElem.current.playbackRate = speedMode;
                setPlayAll(true);
                await safePlay();
            } catch (e) { console.log(e); }
            setisPlaying(true);
        }
    };

    const handleChangeStory = (e) => { setStory(e); setActive(0); setisPlaying(false); };
    const clickMic = async () => { await SpeechRecognition.startListening(); };
    const stopMic = async () => { await SpeechRecognition.stopListening(); };

    const formatTime = (s) => {
        if (!s || isNaN(s)) return '0:00';
        const m = Math.floor(s / 60);
        const sec = Math.floor(s % 60);
        return `${m}:${sec < 10 ? '0' : ''}${sec}`;
    };

    const downloadAudio = () => {
        const src = getAudioSrc();
        if (!src) { message.error('Không tìm thấy file âm thanh!'); return; }
        const link = document.createElement('a');
        link.href = src;
        link.download = `${dataLesson?.title || 'audio'}_${story.replace(/\s/g, '_')}.mp3`;
        link.target = '_blank';
        link.click();
    };

    // Camera recording
    const cameraPreviewRef = useRef(null);
    const cameraStreamRef = useRef(null);

    const startRecording = async () => {
        try {
            // Check permission status first
            if (navigator.permissions) {
                try {
                    const permStatus = await navigator.permissions.query({ name: 'camera' });
                    if (permStatus.state === 'denied') {
                        message.error('Quyền truy cập camera đã bị từ chối. Vui lòng vào Cài đặt trình duyệt → Quyền riêng tư → Camera để cho phép.');
                        return;
                    }
                } catch (e) { /* permissions API not supported for camera, continue */ }
            }

            const stream = await navigator.mediaDevices.getUserMedia({
                video: { facingMode: 'user', width: { ideal: 1280 }, height: { ideal: 720 } },
                audio: true
            });
            cameraStreamRef.current = stream;
            if (cameraPreviewRef.current) {
                cameraPreviewRef.current.srcObject = stream;
            }

            // Find supported mimeType
            const mimeTypes = ['video/webm;codecs=vp9,opus', 'video/webm;codecs=vp8,opus', 'video/webm', 'video/mp4'];
            let selectedMime = '';
            for (const mime of mimeTypes) {
                if (MediaRecorder.isTypeSupported(mime)) { selectedMime = mime; break; }
            }

            const recorderOptions = selectedMime ? { mimeType: selectedMime } : {};
            const recorder = new MediaRecorder(stream, recorderOptions);
            const chunks = [];
            recorder.ondataavailable = (e) => { if (e.data.size > 0) chunks.push(e.data); };
            recorder.onstop = () => {
                const ext = selectedMime.includes('mp4') ? 'mp4' : 'webm';
                const blob = new Blob(chunks, { type: selectedMime || 'video/webm' });
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url; a.download = `recording_${dataLesson?.title || 'lesson'}.${ext}`;
                a.click(); URL.revokeObjectURL(url);
                message.success('Đã lưu bản ghi hình!');
                stream.getTracks().forEach(t => t.stop());
                if (cameraPreviewRef.current) cameraPreviewRef.current.srcObject = null;
                cameraStreamRef.current = null;
            };
            recorder.start();
            setMediaRecorder(recorder);
            setIsRecording(true);
            message.success('Đang ghi hình...');
        } catch (err) {
            console.error('Recording error:', err);
            if (err.name === 'NotAllowedError') {
                message.error('Bạn đã từ chối quyền truy cập camera. Vui lòng bấm biểu tượng 🔒 trên thanh địa chỉ → cho phép Camera → tải lại trang.');
            } else if (err.name === 'NotFoundError') {
                message.error('Không tìm thấy camera. Vui lòng kiểm tra webcam đã kết nối chưa.');
            } else if (err.name === 'NotReadableError') {
                message.error('Camera đang được sử dụng bởi ứng dụng khác. Vui lòng đóng ứng dụng đó rồi thử lại.');
            } else {
                message.error('Không thể bắt đầu ghi hình: ' + (err.message || err.name));
            }
        }
    };

    const stopRecording = () => {
        if (mediaRecorder) {
            mediaRecorder.stop();
            setIsRecording(false);
            setMediaRecorder(null);
        }
    };

    const ts = timestamps[toLowerCamelCase(story)] || [];
    const audioSrc = getAudioSrc();

    return (
        <div className="min-h-screen bg-gradient-to-b from-[#0c1929] to-[#162d50]">
            {/* Hidden Audio */}
            {audioSrc && (
                <audio src={audioSrc} ref={audioElem} onTimeUpdate={onPlaying} crossOrigin="anonymous"
                    onEnded={() => { setisPlaying(false); setPlayAll(false); }} />
            )}

            {/* Header Bar */}
            <div className="bg-[#0a1628]/80 backdrop-blur-md border-b border-white/10 sticky top-0 z-20">
                <div className="max-w-screen-xl mx-auto px-4 py-3 flex items-center justify-between">
                    <Breadcrumb
                        className="[&_.ant-breadcrumb-link]:text-blue-300 [&_.ant-breadcrumb-separator]:text-blue-400 [&_a]:text-blue-300 [&_a:hover]:text-white"
                        items={[
                            { title: <Link to="/"><HomeOutlined /> Trang chủ</Link> },
                            { title: <Link to="/topic">Topic</Link> },
                            { title: <Link to={"/lesson/" + dataLesson?.course_slug}>{dataLesson?.course_title}</Link> },
                            { title: <span className="text-white">{dataLesson?.title}</span> },
                        ]}
                    />
                    {isRecording && (
                        <div className="flex items-center gap-2 bg-red-500/20 px-3 py-1 rounded-full">
                            <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></div>
                            <span className="text-red-400 text-sm font-medium">Đang ghi hình</span>
                        </div>
                    )}
                </div>
            </div>

            <div className="max-w-screen-xl mx-auto px-4 py-6">
                {/* Title */}
                <h1 className="text-2xl md:text-3xl font-bold text-white text-center mb-6">{dataLesson?.title}</h1>

                {/* Track Selector */}
                <div className="flex justify-center mb-6">
                    <div className="bg-[#1a2d4a] rounded-xl p-1 inline-flex gap-1 flex-wrap justify-center">
                        {options.map(opt => (
                            <button
                                key={opt}
                                onClick={() => handleChangeStory(opt)}
                                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                                    story === opt
                                        ? 'bg-blue-500 text-white shadow-lg shadow-blue-500/30'
                                        : 'text-blue-200 hover:text-white hover:bg-white/10'
                                }`}
                            >
                                {opt}
                            </button>
                        ))}
                    </div>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                    {/* Left: Lyrics Panel */}
                    <div className="lg:col-span-2">
                        <div className="bg-[#1a2d4a] rounded-2xl p-6 shadow-xl border border-white/5">
                            <div className="flex items-center justify-between mb-4">
                                <h3 className="text-white font-semibold flex items-center gap-2">
                                    <SoundOutlined className="text-blue-400" /> Lyrics / Transcript
                                </h3>
                                <span className="text-blue-300 text-sm bg-blue-500/10 px-3 py-1 rounded-full">
                                    Câu {active + 1}/{ts.length || 0}
                                </span>
                            </div>

                            {/* LRC Display */}
                            <div ref={lyricsContainerRef} className="bg-[#0f1e35] rounded-xl p-4 max-h-[350px] overflow-y-auto scrollbar-thin">
                                {lyric?.map((line, i) => (
                                    <div
                                        key={i}
                                        data-lyric-index={i}
                                        onClick={() => { setActive(i); setShowAnswer(false); pause(); }}
                                        className={`px-4 py-3 rounded-lg cursor-pointer mb-1 transition-all ${
                                            active === i
                                                ? 'bg-blue-500/20 border-l-4 border-blue-400 text-blue-100'
                                                : 'text-gray-400 hover:text-gray-200 hover:bg-white/5 border-l-4 border-transparent'
                                        }`}
                                    >
                                        <span className="text-xs text-gray-500 mr-3">{i + 1}</span>
                                        <span className={`${active === i ? 'font-semibold' : ''}`} style={{ fontSize: `${subtitleFontSize}px` }}>
                                            {line}
                                        </span>
                                        {showTranslation && (
                                            <div className="mt-1 text-gray-500 italic" style={{ fontSize: `${translationFontSize}px` }}>
                                                {/* Translation placeholder - sẽ hiển thị khi có dữ liệu dịch */}
                                                <span className="opacity-50">—</span>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>

                            {/* Answer Section */}
                            <div className="mt-4">
                                <Form layout="vertical" form={form} onFinish={onSubmit}>
                                    <Form.Item name="text" className="mb-3">
                                        <TextArea
                                            placeholder="Nghe và gõ lại những gì bạn nghe được..."
                                            autoSize={{minRows: 2, maxRows: 4}}
                                            className="!bg-[#0f1e35] !border-blue-500/30 !rounded-xl !text-white !placeholder-gray-500"
                                        />
                                    </Form.Item>
                                    <div className="flex items-center gap-3 flex-wrap">
                                        {!showAnswer ? (
                                            <>
                                                <Button type="primary" htmlType="submit" icon={<CheckOutlined />}
                                                    className="!bg-green-500 !border-green-500 !rounded-lg hover:!bg-green-600">
                                                    Kiểm tra
                                                </Button>
                                                <Button
                                                    onClick={!listening ? clickMic : stopMic}
                                                    icon={<AudioFilled />}
                                                    className={`!rounded-lg ${listening
                                                        ? '!bg-red-500 !border-red-500 !text-white'
                                                        : '!bg-orange-500 !border-orange-500 !text-white'}`}
                                                >
                                                    {listening ? 'Dừng' : 'Luyện nói'}
                                                </Button>
                                            </>
                                        ) : (
                                            <Button onClick={() => setShowAnswer(false)} icon={<EyeInvisibleOutlined />}
                                                className="!bg-gray-600 !border-gray-600 !text-white !rounded-lg">
                                                Ẩn đáp án
                                            </Button>
                                        )}
                                    </div>
                                </Form>

                                {/* Answer Display */}
                                {showAnswer && (
                                    <div className="mt-4 bg-[#0f1e35] rounded-xl p-4">
                                        <p className="text-gray-400 text-xs mb-2 uppercase tracking-wider">Đáp án:</p>
                                        <div className="mb-3">
                                            {lyric && lyric[active]?.split(' ')?.map((word, i) => (
                                                <span className="text-lg font-semibold mr-1" key={i}
                                                    style={{
                                                        color: dataUserListening
                                                            ?.filter(el => el.track === toLowerCamelCase(story))
                                                            ?.find(lis => +lis.position === active)
                                                            ?.text.replace(/[!@#$%^&*(),.?"":{}|<>""]/g, '').toLowerCase()
                                                            .split(' ').includes(word.replace(/[!@#$%^&*(),.?"":{}|<>""]/g, '').toLowerCase())
                                                            ? '#10b981' : '#ef4444'
                                                    }}>
                                                    {word}
                                                </span>
                                            ))}
                                        </div>
                                        <div className="flex items-center gap-4">
                                            <Progress
                                                type="circle" size={56}
                                                percent={dataUserListening
                                                    ?.filter(el => el.track === toLowerCamelCase(story))
                                                    ?.find(el => el.position === active)?.point || 0}
                                                strokeColor={{ '0%': '#3b82f6', '100%': '#10b981' }}
                                                trailColor="#1a2d4a"
                                                format={(p) => <span className="text-white text-sm font-bold">{p}%</span>}
                                            />
                                            <span className="text-gray-400 text-sm">Độ chính xác</span>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Right: Controls Panel */}
                    <div className="lg:col-span-1 space-y-4">
                        {/* Action Buttons */}
                        <div className="bg-[#1a2d4a] rounded-2xl p-5 shadow-xl border border-white/5">
                            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Công cụ</h3>
                            <div className="grid grid-cols-2 gap-3">
                                <Tooltip title="Tải file âm thanh">
                                    <button onClick={downloadAudio}
                                        className="flex items-center gap-2 bg-green-500/10 text-green-400 px-4 py-3 rounded-xl hover:bg-green-500/20 transition-all text-sm font-medium w-full">
                                        <DownloadOutlined className="text-lg" /> Tải audio
                                    </button>
                                </Tooltip>
                                <Tooltip title={isRecording ? "Dừng ghi hình" : "Ghi hình bằng camera"}>
                                    <button onClick={isRecording ? stopRecording : startRecording}
                                        className={`flex items-center gap-2 px-4 py-3 rounded-xl transition-all text-sm font-medium w-full ${
                                            isRecording
                                                ? 'bg-red-500/20 text-red-400 hover:bg-red-500/30 animate-pulse'
                                                : 'bg-purple-500/10 text-purple-400 hover:bg-purple-500/20'
                                        }`}>
                                        <VideoCameraOutlined className="text-lg" /> {isRecording ? 'Dừng ghi' : 'Ghi hình'}
                                    </button>
                                </Tooltip>
                                <button onClick={!listening ? clickMic : stopMic}
                                    className={`flex items-center gap-2 px-4 py-3 rounded-xl transition-all text-sm font-medium w-full ${
                                        listening
                                            ? 'bg-orange-500/20 text-orange-400 animate-pulse'
                                            : 'bg-orange-500/10 text-orange-400 hover:bg-orange-500/20'
                                    }`}>
                                    <AudioFilled className="text-lg" /> {listening ? 'Đang nghe...' : 'Luyện nói'}
                                </button>
                                <button onClick={() => setShowSettings(!showSettings)}
                                    className="flex items-center gap-2 bg-blue-500/10 text-blue-400 px-4 py-3 rounded-xl hover:bg-blue-500/20 transition-all text-sm font-medium w-full">
                                    <SettingOutlined className="text-lg" /> Cài đặt
                                </button>
                            </div>
                            {/* Camera Preview */}
                            {isRecording && (
                                <div className="mt-4">
                                    <video ref={cameraPreviewRef} autoPlay muted playsInline
                                        className="w-full rounded-xl border border-white/10"
                                        style={{ maxHeight: '200px', objectFit: 'cover', transform: 'scaleX(-1)' }} />
                                </div>
                            )}
                        </div>

                        {/* Settings Panel */}
                        {showSettings && (
                            <div className="bg-[#1a2d4a] rounded-2xl p-5 shadow-xl border border-white/5">
                                <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Cài đặt</h3>
                                <div className="space-y-4">
                                    <div>
                                        <p className="text-gray-400 text-xs mb-2">Tốc độ phát</p>
                                        <div className="flex flex-wrap gap-2">
                                            {speeds.map(s => (
                                                <button key={s} onClick={() => changeSpeedMode(s)}
                                                    className={`px-3 py-1.5 rounded-lg text-xs font-bold transition-all ${
                                                        speedMode === s
                                                            ? 'bg-blue-500 text-white shadow-lg shadow-blue-500/30'
                                                            : 'bg-white/10 text-gray-300 hover:bg-white/20'
                                                    }`}>
                                                    {s}x
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                    <div>
                                        <p className="text-gray-400 text-xs mb-2">Lặp lại: {replay - 1 > 0 ? replay - 1 : 0} lần</p>
                                        <Slider min={1} max={11} value={replay} onChange={v => setReplay(v)}
                                            className="[&_.ant-slider-track]:bg-blue-500 [&_.ant-slider-handle]:border-blue-500" />
                                    </div>
                                    <div>
                                        <p className="text-gray-400 text-xs mb-2">Nghỉ giữa lần lặp: {timeReplay}s</p>
                                        <Slider min={0} max={3} step={0.5} value={timeReplay} onChange={v => setTimeReplay(v)}
                                            className="[&_.ant-slider-track]:bg-blue-500 [&_.ant-slider-handle]:border-blue-500" />
                                    </div>

                                    {/* Divider */}
                                    <div className="border-t border-white/10 my-2"></div>

                                    {/* Subtitle Font Size */}
                                    <div>
                                        <p className="text-gray-400 text-xs mb-2 flex items-center gap-1">
                                            <FontSizeOutlined /> Cỡ chữ phụ đề: {subtitleFontSize}px
                                        </p>
                                        <Slider min={12} max={32} value={subtitleFontSize} onChange={v => setSubtitleFontSize(v)}
                                            className="[&_.ant-slider-track]:bg-blue-500 [&_.ant-slider-handle]:border-blue-500" />
                                    </div>

                                    {/* Translation Font Size */}
                                    <div>
                                        <p className="text-gray-400 text-xs mb-2 flex items-center gap-1">
                                            <FontSizeOutlined /> Cỡ chữ phụ đề dịch: {translationFontSize}px
                                        </p>
                                        <Slider min={12} max={28} value={translationFontSize} onChange={v => setTranslationFontSize(v)}
                                            className="[&_.ant-slider-track]:bg-purple-500 [&_.ant-slider-handle]:border-purple-500" />
                                    </div>

                                    {/* Show Translation Toggle */}
                                    <div className="flex items-center justify-between">
                                        <p className="text-gray-400 text-xs flex items-center gap-1">
                                            <EyeOutlined /> Hiện bản dịch
                                        </p>
                                        <Switch
                                            size="small"
                                            checked={showTranslation}
                                            onChange={v => setShowTranslation(v)}
                                            className={showTranslation ? '!bg-blue-500' : ''}
                                        />
                                    </div>

                                    {/* Auto Scroll Toggle */}
                                    <div className="flex items-center justify-between">
                                        <p className="text-gray-400 text-xs flex items-center gap-1">
                                            <RetweetOutlined /> Tự động cuộn
                                        </p>
                                        <Switch
                                            size="small"
                                            checked={autoScroll}
                                            onChange={v => setAutoScroll(v)}
                                            className={autoScroll ? '!bg-blue-500' : ''}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Full Audio Player */}
                        <div className="bg-[#1a2d4a] rounded-2xl p-5 shadow-xl border border-white/5">
                            <h3 className="text-white font-semibold mb-3 text-sm uppercase tracking-wider">
                                <SoundOutlined className="text-blue-400 mr-2" />Trình phát
                            </h3>
                            {audioSrc ? (
                                <audio controls className="w-full [&]:rounded-lg" src={audioSrc} crossOrigin="anonymous"
                                    style={{ filter: 'invert(1) hue-rotate(180deg)', borderRadius: '10px' }} />
                            ) : (
                                <p className="text-gray-500 text-sm">Không có audio cho track này</p>
                            )}
                        </div>
                    </div>
                </div>

                {/* Bottom Audio Controls (fixed) */}
                <div className="fixed bottom-0 left-0 right-0 bg-[#0a1628]/95 backdrop-blur-xl border-t border-white/10 z-30">
                    <div className="max-w-screen-xl mx-auto px-4 py-3">
                        <div className="flex items-center justify-between gap-4">
                            {/* Track info */}
                            <div className="hidden sm:block min-w-0 flex-shrink-0">
                                <p className="text-white text-sm font-semibold truncate max-w-[200px]">{dataLesson?.title}</p>
                                <p className="text-gray-400 text-xs">{story} • Câu {active + 1}/{ts.length || 0}</p>
                            </div>

                            {/* Playback controls */}
                            <div className="flex items-center gap-2 sm:gap-4">
                                <button onClick={() => { setActive(Math.max(0, active - 1)); setShowAnswer(false); pause(); }}
                                    className="text-gray-300 hover:text-white p-2 transition-colors">
                                    <StepBackwardOutlined className="text-xl" />
                                </button>
                                <button onClick={PlayPause}
                                    className="bg-blue-500 hover:bg-blue-600 text-white w-12 h-12 rounded-full flex items-center justify-center shadow-lg shadow-blue-500/30 transition-all hover:scale-105">
                                    {isPlaying
                                        ? <PauseCircleFilled className="text-2xl" />
                                        : <PlayCircleFilled className="text-2xl" />}
                                </button>
                                <button onClick={() => { setActive((active + 1) % (ts.length || 1)); setShowAnswer(false); pause(); }}
                                    className="text-gray-300 hover:text-white p-2 transition-colors">
                                    <StepForwardOutlined className="text-xl" />
                                </button>
                            </div>

                            {/* Speed + Download */}
                            <div className="flex items-center gap-2 sm:gap-3">
                                <button onClick={() => {
                                    const idx = speeds.indexOf(speedMode);
                                    changeSpeedMode(speeds[(idx + 1) % speeds.length]);
                                }}
                                    className="bg-white/10 text-blue-300 px-3 py-1.5 rounded-lg text-xs font-bold hover:bg-white/20 transition-all">
                                    {speedMode}x
                                </button>
                                <Tooltip title="Tải audio">
                                    <button onClick={downloadAudio} className="text-green-400 hover:text-green-300 p-2">
                                        <DownloadOutlined className="text-lg" />
                                    </button>
                                </Tooltip>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
